const sanitize = (value) => {
  if (typeof value !== "string") {
    return "";
  }

  return value.trim();
};

export default function getDisplayName(user) {
  if (!user) {
    return null;
  }

  const name = sanitize(user.name);

  if (name.length < 2) {
    return null;
  }

  return name;
}
